<div class="card bg-dark-lighter text-white fx-cms-credit" id="list-credit-Card">
  <div class="card-header">
    <div class="row">
      <div class="col  m-auto">
        {{ "Credit Card Approve" | uppercase }}
      </div>
      <div class="col-auto">
        <!--<button class="btn btn-primary" (click)="navigateTo('list-kyc')">-->
          <!--{{ "KYC Approve" }}-->
        <!--</button>-->
      </div>
    </div>
  </div>
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group search-group">
          <input
            type="text"
            class="form-control bg-dark"
            name="keyword"
            placeholder="username, email"
            [(ngModel)]="condition.keyword"
            (keyup)="onKeyup($event)"
          />
          <div class="input-group-append">
            <button
              class="btn btn-main"
              type="button"
              (click)="onSearch()"
            >
              Search
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-xs-12">
        <div class="table-responsive">
          <table class="rox-table table-bordered bg-dark">
            <thead>
            <tr>
              <th class="text-center" colspan="4">INFORMATION</th>
              <th class="text-center" colspan="2">CARD INFORMATION</th>
              <th class="text-center" colspan="2">CARD DOCUMENT</th>
              <th class="text-center" rowspan="2"></th>
            </tr>
            <tr>
              <th class="text-center">ID</th>
              <th class="text-center">Email</th>
              <th class="text-center">Username</th>
              <th class="text-center">
                Status
                <select (change)="onSearch()" [(ngModel)]="condition.status">
                  <option value="">All</option>
                  <option *ngFor="let card of listCardStatus; let i = index" [value]="i">
                    {{card}}
                  </option>
                </select>
              </th>
              <th class="text-center">Credit Card No.</th>
              <th class="text-center">Expired</th>
              <th class="text-center">Card image</th>
              <th class="text-center">Card on hand</th>
            </tr>
            </thead>
            <tbody>
            <tr
              *ngFor="
                          let item of listCredit
                            | paginate
                              : {
                                  id: 'cmsCreditCard',
                                  itemsPerPage: pageInfo.pageSize,
                                  currentPage: pageInfo.pageIndex,
                                  totalItems: pageInfo.totalRecord
                                };
                          let i = index
                        ">
              <td class="text-center">{{item.id}}</td>
              <td class="text-center">{{item.email}}</td>
              <td class="text-center">{{item.getUsername()}}</td>
              <td class="text-center text-{{item.getStatusCard() | uppercase}}">{{item.getStatusCard()}}</td>
              <td class="text-center">{{item.maskSomeDigit()}}</td>
              <td class="text-center">{{item.expiration}}</td>
              <td class="text-center action-process">
                <div class="action-process__status text-{{getLabelStatusCard(item.cardStatus) | uppercase}}">
                  <ng-container *ngIf="item.cardStatus == 0 && permission.allowCreating">
                    <button class="btn btn-down" type="button" (click)="onChangeCreditCardProcess('card_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeCreditCardProcess('card_status', item.id, 1, i)">Approval</button>
                  </ng-container>
                  <ng-container *ngIf="item.cardStatus != 0">
                    {{getLabelStatusCard(item.cardStatus)}}
                  </ng-container>
                </div>
                <div class="action-process__view" *ngIf="permission.allowCreating">
                  <i *ngIf="item.cardStatus > -1" class="fa fa-eye"(click)="openImages(item, 'card')"></i>
                </div>
              </td>
              <td class="text-center action-process">
                <div class="action-process__status text-{{getLabelStatusCard(item.cardHandStatus) | uppercase}}">
                  <ng-container *ngIf="item.cardHandStatus == 0 && permission.allowCreating">
                    <button class="btn btn-down" type="button" (click)="onChangeCreditCardProcess('card_on_hand_status', item.id, 2, i)">Reject</button>
                    <button class="btn btn-up" type="button"
                            (click)="onChangeCreditCardProcess('card_on_hand_status', item.id, 1, i)">Approval</button>
                  </ng-container>
                  <ng-container *ngIf="item.cardHandStatus != 0">
                    {{getLabelStatusCard(item.cardHandStatus)}}
                  </ng-container>
                </div>
                <div class="action-process__view" *ngIf="permission.allowCreating">
                  <i class="fa fa-eye" *ngIf="item.cardHandStatus > -1" (click)="openImages(item, 'cardHand')"></i>
                </div>
              </td>
              <td class="text-center action-change-amount" *ngIf="permission.allowCreating">
                <a
                  href="javascript:void(0)"
                  class="text-blue-lighter"
                  (click)="getCreditCardInfo(item)"
                  data-bs-toggle="modal"
                  data-bs-target="#modalCreditCardDetail"
                >View</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row mt-15">
      <div class="col">
        <div class="pagination-wrapper">
          <pagination-controls
            id="cmsCreditCard"
            (pageChange)="pageChanged($event)"
            autoHide="true"
            responsive="true"
            previousLabel="Prev"
            nextLabel="Next"
          >
          </pagination-controls>
        </div>
      </div>
    </div>
  </div>
  <fx-lightbox-card #lightboxCard></fx-lightbox-card>
  <div class="modal fade fx-modal" id="modalCreditCardDetail">
    <div class="modal-dialog modal-lg modal-dialog-centered" *ngIf="cardInfo?.id !== undefined">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">
            {{ cardInfo.email + ' (' +  cardInfo.getUsername() + ')' }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body ">
          <table class="rox-table table-bordered bg-dark">
            <thead>
            <tr>
              <th class="text-center">Credit Card Type</th>
              <th class="text-center">Credit Card Name</th>
              <th class="text-center">Credit Card Number</th>
              <th class="text-center">Expiration Date</th>
            </tr>
            </thead>
            <tbody>
              <tr>
                <td class="text-center">{{ 'VISA' }}</td>
                <td class="text-center">{{ cardInfo.name }}</td>
                <td class="text-center">{{ cardInfo.maskSomeDigit()}}</td>
                <td class="text-center">{{ cardInfo.expiration}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
